import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import { initialLicenseState } from './license.state';
import { CoaterLicenseActions } from './license.actions';

const licenseFeature = createFeature({
  name: 'license',
  reducer: createReducer(
    initialLicenseState,

    on(CoaterLicenseActions.loadCoaterLicenses, (state, { pagination, filter, orderBy }) => {
      return { ...state, pagination, filter, orderBy, loading: true };
    }),
    on(CoaterLicenseActions.loadCoaterLicensesSuccess, (state, { licenseNumbers, count }) => ({
      ...state,
      loading: false,
      licenseNumbers,
      licenseNumbersTotalCount: count,
    })),
    on(CoaterLicenseActions.loadCoaterLicensesFailure, (state, { error }) => ({
      ...state,
      loading: false,
      errorMessage: error,
    })),

    on(CoaterLicenseActions.withdrawCoaterLicense, (state) => ({ ...state, saving: true })),
    on(CoaterLicenseActions.withdrawCoaterLicenseSuccess, (state) => ({ ...state, saving: false })),
    on(CoaterLicenseActions.withdrawCoaterLicenseFailure, (state, { error }) => ({
      ...state,
      saving: false,
      errorMessage: error,
    })),

    on(CoaterLicenseActions.grantCoaterLicense, (state) => ({ ...state, saving: true })),
    on(CoaterLicenseActions.grantCoaterLicenseSuccess, (state) => ({ ...state, saving: false })),
    on(CoaterLicenseActions.grantCoaterLicenseFailure, (state, { error }) => ({
      ...state,
      saving: false,
      errorMessage: error,
    }))
  ),
  extraSelectors: ({ selectLicenseState }) => ({
    selectLicenseNumbers: createSelector(selectLicenseState, (state) => {
      return {
        pagination: state.pagination,
        filter: state.filter,
        orderBy: state.orderBy,
        licenseNumbers: state.licenseNumbers,
        totalLicenseNumbersCount: state.licenseNumbersTotalCount,
      };
    }),
  }),
});
export const {
  name: licenseState,
  reducer: licenseReducer,

  selectLicenseState,

  selectLicenseNumbers,
} = licenseFeature;
